interface IntegrationStatusStyle {
  label: string;
  badge: string;
  dot: string;
}

const INTEGRATION_STATUS_STYLES: Record<string, IntegrationStatusStyle> = {
  ACTIVE: {
    label: "Active",
    badge:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/60 dark:bg-emerald-950/40 dark:text-emerald-300",
    dot: "bg-emerald-500",
  },
  PENDING: {
    label: "Pending",
    badge:
      "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900/60 dark:bg-sky-950/40 dark:text-sky-300",
    dot: "bg-sky-500",
  },
  INACTIVE: {
    label: "Inactive",
    badge:
      "border-zinc-200 bg-zinc-100 text-zinc-600 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
    dot: "bg-zinc-400",
  },
  EXPIRED: {
    label: "Expired",
    badge:
      "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-300",
    dot: "bg-amber-500",
  },
};

const FALLBACK_STYLE: IntegrationStatusStyle = {
  label: "Unknown",
  badge:
    "border-zinc-200 bg-zinc-100 text-zinc-600 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
  dot: "bg-zinc-400",
};

export function normalizeIntegrationStatus(status?: string | null): string {
  if (!status?.trim()) return "INACTIVE";
  return status.trim().toUpperCase().replace(/[\s-]+/g, "_");
}

export function getIntegrationStatusStyle(status?: string | null): IntegrationStatusStyle {
  const key = normalizeIntegrationStatus(status);
  const style = INTEGRATION_STATUS_STYLES[key];
  if (style) return style;

  const label = key
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(" ");

  return { ...FALLBACK_STYLE, label: label || FALLBACK_STYLE.label };
}

export function formatIntegrationCategory(category?: string | null): string {
  if (!category?.trim()) return "Other";
  return category
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(" ");
}

export function formatIntegrationDisplayName(
  name: string,
  alias?: string | null,
  reference?: string | null
): string {
  const trimmedAlias = alias?.trim();
  if (trimmedAlias) return `${name} · ${trimmedAlias}`;
  const trimmedReference = reference?.trim();
  if (trimmedReference) return `${name} · ${trimmedReference}`;
  return name;
}

export function getIntegrationReferenceLabel(
  integrationDescription?: string | null,
  reference?: string | null
): string {
  return integrationDescription?.trim() || reference?.trim() || "";
}
